import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const rootElement = document.getElementById("root"); 

  useEffect(() => {
    rootElement.scrollTo(0, 0);
  }, [pathname, rootElement]);

  return null;
}